import formatBillingInterval from "@/utils/transformBillingInterval";
import type { TBillingInterval } from "@/types/app";
import type { TRecurring } from "@/types/plan-data";

type TRecurringInput = Partial<
  Pick<TRecurring, "interval" | "interval_count" | "interval_type">
>;

export const derivePlanIntervalType = (
  recurring: TRecurringInput | null | undefined,
): TBillingInterval | undefined => {
  if (recurring?.interval_type) return recurring.interval_type;

  const interval = recurring?.interval;
  if (!interval) return undefined;

  return formatBillingInterval(interval, recurring?.interval_count ?? 1);
};

export default derivePlanIntervalType;
